import { makeStyles, Theme } from '@material-ui/core';
import { CHART_COLORS } from './Statistics';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    height: '100%',
    overflowX: 'hidden'
  },
  searchBar: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '20px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.2)',
    paddingBottom: '30px',
    paddingTop: '30px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'center',
      padding: '30px 0 30px 0',
    },
  },
  title: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#000',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('md')]: {
      height: '80px',
      display: 'flex',
      alignItems: 'center',
    },
  },
  search: {
    display: 'flex',
    gap: '10px',
    [theme.breakpoints.down('md')]: {
      // flexDirection: 'column',
      width: '100%',
    },
  },
  date: {
    boxSizing: 'border-box',
    width: '100%',

    '& input': {
      padding: '12px',
    },
    '&.marginInit': {
      marginBottom: '0px',
      marginTop: '0px',
    },
  },
  searchButton: { width: '180px' },
  sections: { display: 'flex', flexDirection: 'column', gap: '20px' },

  // 섹션 별 공통 스타일
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.2)',
    paddingBottom: '20px',
    padding: '10px',
  },
  sectionTitleBox: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  sectionTitle: {
    fontSize: '20px',
    fontWeight: 'bold',
  },
  sectionBody: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
  },

  // 개별 스타일
  pieCharts: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10,
    [theme.breakpoints.down('md')]: {
      gap: 0,
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },

  pieChartWithStorageinfo: {
    display: 'flex',
    gap: '20px',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      gap: 0,
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
    },
  },

  pieChart: {
    position: 'relative',
    width: 'fit-content',
    '& path:focus': {
      outline: 'none',
    },
  },
  pieChartCenter: {
    position: 'absolute',
    backgroundColor: '#fff',
    borderRadius: '9999px',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 800,
    zIndex: 50,
  },
  selectAndDownloadButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '18px',
  },

  storageInfo: {
    display: 'flex',
    flexShrink: 0,
    flexGrow: 0,
    flexDirection: 'column',
    gap: 10,
    paddingTop: 40,
    whiteSpace: 'nowrap',
  },
  storageName: {
    fontSize: 36,
    fontWeight: 800,
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  statusDot: {
    width: '8px',
    height: '8px',
    borderRadius: '9999px',
  },
  storageDetail: {
    display: 'flex',
    gap: 6,
    fontSize: 14,
    color: 'grey',
  },
  storageDetailData: {
    fontWeight: 900,
    color: 'black',
  },
}));
